import React, { Component } from 'react';
import { Column, Row } from "@sm/helpers/simple-flexbox";

import ManageCompany from '@modules/companies/ManageCompany';

class ViewCompany extends Component {
  state = {};

  render() {
    return <Row flexGrow={ 1 } className='module apidata viewClient' vertical='start'>
      <Column flexGrow={ 1 }>
        <ManageCompany companyId={ this.props.match.params.companyId } viewOrEdit={ 1 }/>
      </Column>
    </Row>;
  }
}

export default ViewCompany;